export default function genererCritereRechercheCatalogueProduitNonCom() {
  return {
    auto: '',
    categorie: [],
    actif: true,
    societeId: null,
    sansProduitMateriel: true,
    motifNonCommercialisableIds: [],
    mairieEtNonCommercialisable: true,
    agencesId: [],
  };
}
